import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { forms } from "../components/Data";
import "../scss/forms.css";

const FormDetail = () => {
  const { formId } = useParams();
  const form = forms.find((f) => f.id === formId);

  const initialFormData = form
    ? form.fields.reduce((acc, field) => {
        acc[field.name] = "";
        return acc;
      }, {})
    : {};

  const [formData, setFormData] = useState(initialFormData);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  if (!form) {
    return (
      <div className="form-detail">
        <div className="form-not-found">
          <h2>Form not found</h2>
          <Link to="/test/forms" className="back-link">
            &larr; Back to Forms
          </Link>
        </div>
      </div>
    );
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      const response = await fetch(
        "https://api.pipeero.com/f/form_924f0c8fdb88c615ffe07dd72c94c7a0",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit form");
      }

      setSubmitted(true);
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const renderField = (field) => {
    switch (field.type) {
      case "text":
      case "email":
        return (
          <input
            type={field.type}
            id={field.name}
            name={field.name}
            value={formData[field.name]}
            onChange={handleChange}
            placeholder={field.placeholder}
            required={field.required}
          />
        );
      case "textarea":
        return (
          <textarea
            id={field.name}
            name={field.name}
            value={formData[field.name]}
            onChange={handleChange}
            placeholder={field.placeholder}
            required={field.required}
            rows={5}
          />
        );
      case "select":
        return (
          <select
            id={field.name}
            name={field.name}
            value={formData[field.name]}
            onChange={handleChange}
            required={field.required}
          >
            <option value="">Select an option</option>
            {field.options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        );
      default:
        return null;
    }
  };

  if (submitted) {
    return (
      <div className="form-detail">
        <div className="form-success">
          <div className="success-icon">&#10003;</div>
          <h2>Thank you!</h2>
          <p>Your response has been submitted successfully.</p>
          <Link to="/test/forms" className="back-link">
            &larr; Back to Forms
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="form-detail">
      <div className="form-detail-header">
        <Link to="/test/forms" className="back-link">
          &larr; Back to Forms
        </Link>
        <h1>{form.name}</h1>
        <p>{form.description}</p>
      </div>

      <form onSubmit={handleSubmit} className="form-container">
        {form.fields.map((field) => (
          <div key={field.name} className="form-field">
            <label htmlFor={field.name}>
              {field.label}
              {field.required && <span className="required">*</span>}
            </label>
            {renderField(field)}
          </div>
        ))}

        {error && <div className="form-error">{error}</div>}

        <button type="submit" className="submit-btn" disabled={submitting}>
          {submitting ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default FormDetail;
